import React from 'react'

const SideTitle = ({ data }) => {
  return <h2 className="font-bold text-2xl my-3 ml-4 md:ml-0">{data}</h2>
}

export default SideTitle
